import get from "lodash.get";
import MessageError from "@/helpers/MessageError";

const state = {
    payload: {},
    availableServerLicenses: 0,
    availableClusterLicenses: 0,
    availableSingleServerLicenses: 0,
    availableClusterableServerLicenses: 0,
};

const getters = {
    hasPayload(state) {
        return state.payload.hasOwnProperty("license_details");
    },
    hasListing(state) {
        return state.payload.has_listing;
    },
    hasPendingEntities(state) {
        return (
            get(state, "payload.entities_and_test_servers.pending_entities", false) &&
            state.payload.entities_and_test_servers.pending_entities.length > 0
        );
    },
    hasServersInTesting(state) {
        return (
            get(state, "payload.entities_and_test_servers.test_servers", false) &&
            state.payload.entities_and_test_servers.test_servers.length > 0
        );
    },
    hasSingleServers(state) {
        if (typeof get(state, "payload.entities_and_test_servers.entities") === "undefined") {
            return false;
        }

        if (state.payload.entities_and_test_servers.entities.length === 0) {
            return false;
        }

        let counter = 0;

        state.payload.entities_and_test_servers.entities.forEach((entity) => {
            if (entity.entity_type === "69002") counter++;
        });

        return counter > 0;
    },
    hasClusters(state) {
        if (typeof get(state, "payload.entities_and_test_servers.entities") === "undefined") {
            return false;
        }

        if (state.payload.entities_and_test_servers.entities.length === 0) {
            return false;
        }

        let counter = 0;

        state.payload.entities_and_test_servers.entities.forEach((entity) => {
            if (entity.entity_type === "69001") counter++;
        });

        return counter > 0;
    }
};

const actions = {
    getPayload({ commit }) {
        this._vm.$axios.get("/manager/entities_data/get_entities").then((response) => {
            commit("setPayload", response.data);
            commit("setAvailableLicenses", response.data);
        });
    },

    async deleteTestServer({ commit, state }, entity) {
        let response = await this._vm.$axios
            .get(
                this._vm.$laroute.action("entities_delete_test_server", {
                    test_server_id: entity.test_server_id
                })
            )
            .catch((error) => {
                throw new MessageError({
                    title: "Error",
                    message: "Delete failed."
                });
            });

        if (response.data.delete_status === "OK") {
            resolve({
                message: `${entity.server_easy_name} test server deleted successfully.`,
                entity: entity
            });
        } else {
            throw new MessageError({
                title: "something bad happened",
                message: `Failed to delete ${entity.server_easy_name} test server.`
            });
        }
    }
};

const mutations = {
    setPayload(state, value) {
        state.payload = value;
    },
    setAvailableLicenses(state, value) {
        state.availableServerLicenses =
            state.payload.license_details.settings.server_licenses - state.payload.license_details.deployed_servers;
        state.availableClusterLicenses =
            state.payload.license_details.settings.cluster_licenses - state.payload.license_details.deployed_clusters;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
